import {
  apiRequest,
  pangkatCreate,
  pangkatrankGroup,
} from "../../../../../services/adapters/kepegawaian/pangkatService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      pangkatCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchRankGroup = async (query) => {
    return await apiRequest(
      "get",
      pangkatrankGroup,
      {
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
